import { render, staticRenderFns } from "./Consultashistorial.vue?vue&type=template&id=05adf69f&scoped=true&"
import script from "./Consultashistorial.vue?vue&type=script&lang=js&"
export * from "./Consultashistorial.vue?vue&type=script&lang=js&"
import style0 from "./Consultashistorial.vue?vue&type=style&index=0&id=05adf69f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05adf69f",
  null
  
)

export default component.exports